(function() {
    'use strict';

    angular
        .module('sideApp')
        .controller('ActividadesEvaDoceController', ActividadesEvaDoceController);

    ActividadesEvaDoceController.$inject = ['$scope', '$state', 'Principal', 'ActividadesEvaluacion', 'ParseLinks', 'AlertService', 'pagingParams', 'paginationConstants','AniosEscolares','Instituciones','NivelesEducativosService','ModelosEducativosService'];

    function ActividadesEvaDoceController ($scope, $state, Principal, ActividadesEvaluacion, ParseLinks, AlertService, pagingParams, paginationConstants,AniosEscolares,Instituciones,NivelesEducativosService,ModelosEducativosService) {
        var vm = this;
        
        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.itemsPerPage = paginationConstants.itemsPerPage;
        vm.search=search;
        vm.currentSearch=pagingParams.search;
        vm.anioSeleccionado = pagingParams.anio;
        vm.institucionSeleccionada = pagingParams.institucion;
        vm.modeloSeleccionado=pagingParams.modelo;
        vm.nivelSeleccionado=pagingParams.nivel;
        vm.rolGralSIDE=pagingParams.rolGralSIDE
        
        cargarDropdownAniosEscolares();
        cargarDropdownDependencia();
        cargarDropdownModeloNivelEducativo();
        loadAll();
        vm.limpiar = limpiar;

        function loadAll () {
        	ActividadesEvaluacion.query({
                page: pagingParams.page - 1,
                size: vm.itemsPerPage,
                sort: sort(),
                search:  vm.currentSearch,
                anio: vm.anioSeleccionado,
                institucion : vm.institucionSeleccionada,
                modelo: vm.modeloSeleccionado,
                nivel: vm.nivelSeleccionado	
            }, onSuccess, onError);
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.actividades = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage (page) {
            vm.page = page;
            vm.transition();
        }

        function transition () {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch,
                anio: vm.anioSeleccionado,
                institucion : vm.institucionSeleccionada,
                modelo: vm.modeloSeleccionado,
                nivel: vm.nivelSeleccionado
            });
        }
        
        function cargarDropdownAniosEscolares(){
        	vm.aniosEscolares=AniosEscolares.query();
        }
        

		function cargarDropdownDependencia() {
//			console.log(vm.rolGralSIDE);
			if(vm.rolGralSIDE){
				vm.instituciones = Instituciones.query();
			}
//			vm.instituciones = Instituciones.query();
		}
		
		function cargarDropdownModeloNivelEducativo() {
			vm.niveles=NivelesEducativosService.getAll();
        	vm.modelos=ModelosEducativosService.getAll();
		}
		
		function limpiar() {
        	vm.modeloSeleccionado=null;
        }

		function search() {
			if (vm.anioSeleccionado == null)
				return;
			if (vm.institucionSeleccionada == null)
				return;
			
			$state.transitionTo($state.$current, {
				page : 0,
				sort : vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
				search : vm.currentSearch,
				anio : vm.anioSeleccionado,
				institucion : vm.institucionSeleccionada,
				modelo: vm.modeloSeleccionado,
	            nivel: vm.nivelSeleccionado
			}, onSuccess);
			
			function onSuccess(data, headers) {
				vm.links = ParseLinks.parse(headers('link'));
				vm.totalItems = headers('X-Total-Count');
				vm.queryCount = vm.totalItems;
				vm.actividades = data;
				vm.page = pagingParams.page;
			}
		}
    }
})();
